import { gql } from '@apollo/client';

export const BOOK_INTERVIEW_SLOT = gql`
  mutation BookInterviewSlot($input: BookInterviewSlotInput!) {
    bookInterviewSlot(input: $input) {
      id
    }
  }
`;

export const SET_SCHEDULE = gql`
  mutation SetSchedule($input: SetScheduleInput!) {
    setSchedule(input: $input) {
      id
    }
  }
`;

export const SET_MY_SCHEDULE = gql`
  mutation SetMySchedule($input: SetMyScheduleInput!) {
    setMySchedule(input: $input) {
      id
    }
  }
`;

export const SEND_STORE_MANUAL_INTERVIEW_INVITE = gql`
  mutation SendStoreManualInterviewInvite(
    $input: SendManualStoreInterviewInviteInput!
  ) {
    sendStoreManualInterviewInvite(input: $input) {
      id
    }
  }
`;
